import * as React from 'react';

function SvgMessageStroke2(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.423 21.255A1.13 1.13 0 015.3 20.12V9.433c0-.621.5-1.133 1.123-1.133H23.91a1.13 1.13 0 011.124 1.133V20.12c0 .622-.5 1.134-1.124 1.134h-2.334L18.148 24.2a1 1 0 01-1.651-.758v-2.188H6.423zM6.7 9.7v10.155h11.197v2.715l3.16-2.715h2.577V9.7H6.7zm2.8 4.8a1 1 0 102 0 1 1 0 00-2 0zm6 1a1 1 0 110-2 1 1 0 010 2zm4-1a1 1 0 102 0 1 1 0 00-2 0z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgMessageStroke2;
